<template>
  <div class="admin-layout d-flex" style="min-height: 100vh; background: #f4f6fa;">
    <!-- 左侧导航 -->
    <aside class="admin-sidebar" style="width: 200px; min-height: 100vh; background: #1e2a3a; flex-shrink: 0;">
      <div class="sidebar-brand px-3 py-4 text-white font-weight-bold" style="font-size: 1.1rem; border-bottom: 1px solid #2d3d51;">
        后台管理
      </div>
      <nav class="mt-2">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="sidebar-item d-flex align-items-center px-3 py-2 text-white-50"
          active-class="sidebar-item-active"
          style="text-decoration: none; font-size: 0.9rem; transition: background 0.2s;"
        >
          <span class="mr-2">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </router-link>
      </nav>
    </aside>

    <!-- 右侧内容 -->
    <main class="flex-grow-1 p-4">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data: function() {
    return {
      menuItems: [
        { path: '/admin/api-auth', icon: '[KEY]', label: 'API 权限管理' }
      ]
    }
  },
  created: function() {
    if (!this.isAdmin()) {
      this.$router.replace('/home')
    }
  },
  methods: {
    isAdmin: function() {
      try {
        // 方案1: 从 user_info 读取 (Flask 邮箱/微信登录存储的 key)
        // roles 是逗号分隔字符串, 如 "ADMIN" 或 "ADMIN,USER"
        var raw = localStorage.getItem('user_info')
        if (raw) {
          var info = JSON.parse(raw)
          var roles1 = (info.roles || '').toLowerCase()
          if (roles1.indexOf('admin') !== -1) return true
        }
        // 方案2: 从 JWT Token payload 中解码角色 (FastAPI 登录颁发的 token)
        var token = localStorage.getItem('token')
        if (token) {
          var parts = token.split('.')
          if (parts.length === 3) {
            var payload = JSON.parse(atob(parts[1]))
            var roles2 = (payload.roles || '').toLowerCase()
            if (roles2.indexOf('admin') !== -1) return true
          }
        }
        return false
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>
.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff !important;
}
.sidebar-item-active {
  background: #2563eb !important;
  color: #fff !important;
}
</style>
